import 'bootstrap';
import Vue from 'vue';
import App from './App.vue';
import i18n from './i18n';
import store from './store';
import router from './router';
import $ from 'jquery';
import sanitizeHtml from 'sanitize-html';
import { AllHtmlEntities } from 'html-entities';
import './logger';
import './components/Steps';
import './components/Progress';
import './components/Tooltip';
import './components/Dump';

Vue.config.productionTip = false;

const sanitizeOptions = {
    allowedTags: [
        'b', 'i', 'em', 'strong', 'a', 'sup', 'br', 'p', 'img',
        'h3', 'h4', 'h5', 'h6', 'blockquote', 'p', 'a', 'ul', 'ol',
        'nl', 'li', 'b', 'i', 'strong', 'em', 'strike', 'code', 'hr', 'br', 'div',
        'table', 'thead', 'caption', 'tbody', 'tr', 'th', 'td', 'pre',
    ],
};
const entites = new AllHtmlEntities();
const sanitizeTextOptions = {
    allowedTags: [],
};

Vue.prototype.$sanatize = (html: string) => {
    return sanitizeHtml(html, sanitizeOptions);
};

Vue.prototype.$sanatizeText = (html: string) => {
    return entites.decode(sanitizeHtml(html, sanitizeTextOptions));
};

store.dispatch('init').then(() => {
    new Vue({
        i18n,
        router,
        store,
        render: (h) => h(App),
    }).$mount('#bacon-vue');
}, (error) => {
    Vue.$log.error('Could not initialize:', error);
});

declare module 'vue/types/vue' {
    interface Vue {
        $sanatize: (html: string) => string;
        $sanatizeText: (html: string) => string;
    }
}
